import { useState } from "react";
import { Modal, Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { deleteTicket } from "../helpCenter.service";

type Props = {
  open: boolean;
  ticketId: string | null;
  onClose: () => void;
  onDeleted: () => void;
};

const DeleteTicketsModal = ({ open, ticketId, onClose, onDeleted }: Props) => {
  const { t } = useTranslation("helpCenter");
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!ticketId) return;
    setLoading(true);
    try {
      await deleteTicket(ticketId);
      onDeleted();
      onClose();
    } catch {
      // error handled by interceptor
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      closable
    >
      <div className="delete-modal-content">
        <InfoCircleOutlined className="delete-modal-icon" />
        <h3>{t("deleteModal.title")}</h3>
        <p>
          {t("deleteModal.description")}{" "}
          <strong>{t("deleteModal.confirm")}</strong>
        </p>

        <div className="delete-modal-actions">
          <Button onClick={onClose} disabled={loading}>
            {t("deleteModal.cancel")}
          </Button>
          <Button
            type="primary"
            onClick={handleDelete}
            loading={loading}
          >
            {t("deleteModal.delete")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTicketsModal;
